import { Link } from '@/components/common/Link';
import { useState, useEffect, useRef } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuoteButton } from "@/components/common/QuoteButton";
export default function PorcelainPavingHero() {
  const [scrollY, setScrollY] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const bars = ["Trade discount available", "Free Nationwide Delivery", "Nationwide Showrooms", "Split packs available"];
  return <section ref={sectionRef} className="dark" style={{
    fontFamily: "'Cormorant Garamond', serif"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600;700&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="bg-background text-foreground overflow-hidden">

        

        <div className="relative grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-6 relative overflow-hidden h-[160px] sm:h-[200px] lg:h-auto lg:min-h-full">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/Heritage-chalk-porcelain_Hero_14.04.26.webp" alt="Porcelain Paving" className="w-full h-auto object-cover absolute inset-0 w-full h-full" style={{
            transform: `translateY(${scrollY * 0.08}px)`
          }} />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/80 hidden lg:block" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent lg:hidden" />
          </div>

          <div className={`lg:col-span-6 flex flex-col items-center justify-center text-center px-6 sm:px-8 lg:px-12 py-6 lg:py-8 bg-background transition-all duration-1000 ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="space-y-1 mb-3">
              <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground" style={{
              fontFamily: "'DM Sans', sans-serif"
            }}>
                Nick Landscapes
              </p>
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-semibold text-foreground leading-none tracking-tight italic" style={{
              fontFamily: "'Cormorant Garamond', serif"
            }}>Contact Us</h1>
            </div>

            <div className="w-16 h-px bg-primary mb-3 mx-auto" />

            <p className="text-xs sm:text-sm leading-relaxed text-muted-foreground max-w-md mb-5 mx-auto text-center" style={{
            fontFamily: "'DM Sans', sans-serif"
          }}>We'd love to hear from you. Whether you have a question, a comment, or just want to say hello — we're here and ready to help.</p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Button asChild size="lg" className="bg-foreground text-background hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-none px-7 py-5 text-xs tracking-[0.25em] uppercase font-medium" style={{
              fontFamily: "'DM Sans', sans-serif"
            }}>
                <Link to="tel:447459276538" className="flex items-center gap-2">
                  <Phone className="size-3" />
                  <strong>07459276538</strong>
                </Link>
              </Button>
              <QuoteButton scrollToForm style={{
              fontFamily: "'DM Sans', sans-serif"
            }}>
                Get A free Quote
              </QuoteButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}